module.exports = __webpack_public_path__ + "static/media/29DUNON7.34de7e2d.jpg";